import { useEffect, useState } from "react";
import { api } from "../lib/api";

// Reads PUBLISHED content from the Update Center; falls back to built-in copy
// so the site never breaks if the API is unavailable.
export const useContent = (key, fallback) => {
  const [content, setContent] = useState(fallback);
  useEffect(() => {
    let active = true;
    api.get(`/content/${key}`)
      .then(({ data }) => { if (active && data?.content) setContent((c) => ({ ...c, ...data.content })); })
      .catch(() => {});
    return () => { active = false; };
  }, [key]);
  return content;
};
